export default {
  title: 'Perfil de proveedor',
  editButton: 'Editar',
  requiredInformation: {
    title: 'Datos requeridos',
    answerTextLabel: 'Escriba su respuesta...',
    status: {
      rejected: 'Rechazado',
      pending: 'Pendiente',
      answered: 'Respondido'
    }
  },
  editProfile: {
    personalInformation: {
      title: 'Información personal',
      givenNames: 'Nombres',
      surnames: 'Apellidos',
      datePlaceholder: 'dd/mm/yyyy',
      dateOfBirth: 'Fecha de nacimiento',
      rfc: 'RFC',
      curp: 'CURP',
      email: 'Correo',
      cost: 'Costo de consulta',
      responsibilityPolicies: 'Pólizas de Responsabilidad profesional Vigente',
      rcPolicy: 'Fecha de fin de vigencia póliza RC'
    },
    profileImage: {
      title: 'Imagen de perfil',
      changeImage: 'Cambiar imagen'
    },
    personalHomeInformation: {
      title: 'Domicilio',
      street: 'Calle',
      cologne: 'Colonia',
      city: 'Ciudad',
      state: 'Estado',
      postalCode: 'Codigo postal',
      country: 'Pais'
    },
    taxInformation: {
      title: 'Domicilio fiscal',
      street: 'Calle',
      cologne: 'Colonia',
      city: 'Ciudad',
      state: 'Estado',
      postalCode: 'Codigo postal',
      country: 'Pais'
    },
    bankInformation: {
      title: 'Información bancaria',
      name: 'Name',
      clabe: 'Clabe'
    },
    officeInformation: {
      title: 'Consultorios',
      arrayTitle: 'Consultorio {index}',
      street: 'Calle',
      cologne: 'Colonia',
      city: 'Ciudad',
      state: 'Estado',
      postalCode: 'Código Postal',
      country: 'País',
      fax: 'Fax',
      phoneOffice: 'Teléfono Consultorio',
      startTime: 'Horario inicio',
      endTime: 'Horario fin'
    },
    officeHospitalInformation: {
      title: 'Hospital del consultorio',
      arrayTitle: 'Hospital {index}',
      street: 'Calle',
      cologne: 'Colonia',
      city: 'Ciudad',
      state: 'Estado',
      postalCode: 'Código Postal',
      country: 'País',
      fax: 'Fax',
      phoneOffice: 'Teléfono Consultorio',
    },
    academic: {
      title: 'Académico',
      arrayTitle: 'Titulo {index}',
      titleName: 'Nombre del titulo',
      professionalLicense: 'Cedula profesional',
      specialtyArrayTitle: 'Especialidad {index}',
      specialty: 'Especialidad / sub especialidad',
      specialtyId: 'Cédula especialidad'
    },
    steps: {
      providerInformationLabel: 'Información del médico',
      specializationLabel: 'Especialización y lugar de atención',
      cancelButton: 'Cancelar',
      continueButton: 'Continuar'
    }
  },
  guest: {
    title: 'Ingrese la siguiente información',
    retryLabel: 'Puede volver a enviar la solicitud a las {time} segs',
    sendOtpButton: 'Enviar',
    emailHint: 'Ingrese el correo electrónico con el que se registró, para recibir el código de consulta',
    validOtpButton: 'Consultar',
    validationOtpFail: 'El código no es válido'
  },
  doctorInformation: {
    dateOfBirth: 'Fecha de nacimiento',
    rfc: 'RFC',
    curp: 'CURP',
    email: 'Correo',
    medicalCircle: 'Circulo Médico',
    cost: 'Costo de consulta',
    subnet: 'Subred',
    responsibilityPolicies: 'Pólizas de Responsabilidad profesional Vigente',
    rcPolicy: 'Fecha de fin de vigencia póliza RC'
  },
  home: {
    title: 'Domicilio',
    street: 'Calle',
    cologne: 'Colonia',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código Postal',
    country: 'País'
  },
  taxResidence: {
    title: 'Domicilio fiscal',
    street: 'Calle',
    cologne: 'Colonia',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código Postal',
    country: 'País'
  },
  office: {
    title: 'Consultorios',
    arrayTitle: 'Consultorio {index}',
    street: 'Calle',
    cologne: 'Colonia',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código Postal',
    country: 'País',
    fax: 'Fax',
    phoneOffice: 'Teléfono Consultorio',
    startTime: 'Horario inicio',
    endTime: 'Horario fin'
  },
  officeHospital: {
    title: 'Hospital del consultorio',
    arrayTitle: 'Hospital {index}',
    street: 'Calle',
    cologne: 'Colonia',
    city: 'Ciudad',
    state: 'Estado',
    postalCode: 'Código Postal',
    country: 'País',
    fax: 'Fax',
    phoneOffice: 'Teléfono Consultorio',
  },
  bank: {
    title: 'Información bancaria',
    arrayTitle: 'Banco {index}',
    bank: 'Banco',
    clabe: 'Clabe'
  },
  academic: {
    title: 'Académico',
    arrayTitle: 'Titulo {index}',
    titleName: 'Nombre del titulo',
    professionalLicense: 'Cedula profesional',
    specialtyArrayTitle: 'Especialidad {index}',
    specialty: 'Especialidad / sub especialidad',
    specialtyId: 'Cédula especialidad'
  },
  assistant: {
    title: 'Asistentes',
    arrayTitle: 'Asistente {index}',
    givenNames: 'Nombre',
    surnames: 'Apellido',
    dateOfBirth: 'Fecha de nacimiento',
    rfc: 'RFC',
    email: 'Correo'
  },
  status: {
    rejected: {
      title: 'Perfil no aprobado',
      message: 'Algunos de los datos ingresados son incorrectos o no poseen sustento para validación. Por favor, actualice la información o comuniquese con la aseguradora.'
    },
    approved: {
      title: 'Perfil verificado',
      message: 'Todos los datos han sido corroborados por un agente de la aseguradora. Recuerde que si desea editarlos, quedarán pendientes de aprobación.'
    },
    inProgress: {
      title: 'Información pendiente de aprobación',
      message: 'En el transcurso de 48 horas, se revisará la información para corroborar que sea correcta. Nos comunicaremos por email a {email}'
    },
    dataRequired: {
      title: 'Datos requeridos',
      message: 'Se necesita información adicional, consulte la sección "Datos requeridos" para mayor detalle.'
    }
  }
}